import { render, staticRenderFns } from "./UnreadReplyNotice.vue?vue&type=template&id=2842ea72&scoped=true"
import script from "./UnreadReplyNotice.vue?vue&type=script&lang=js"
export * from "./UnreadReplyNotice.vue?vue&type=script&lang=js"
import style0 from "./UnreadReplyNotice.vue?vue&type=style&index=0&id=2842ea72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842ea72",
  null
  
)

export default component.exports